import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import styles from './trustBadge.module.css';

interface TrustBadgeProps {
  mobile?: boolean;
}

export const TrustBadge: FunctionComponent<TrustBadgeProps> = (props) => {
  const { mobile } = props;
  const classList = classNames({
    [styles.trustBadge]: true,
    [styles.mobile]: mobile,
  });

  return (
    <a
      className={classList}
      target="_blank"
      href="https://privacy.truste.com/privacy-seal/validation?rid=3770533b-b691-4636-afef-9dcd99e25c18"
    ></a>
  );
};
